import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import urls, { getCsrfToken } from '../com.zedock.common.script/urls.js';

export async function clicks(path) {


    fetch(`${urls.BASE_URL}` + "/auth/clicks", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-XSRF-TOKEN": getCsrfToken()
        },
        body: JSON.stringify({ 'page': path })
    });
    return;
}

export function useHandleAddToCart() {
    const expressionProduct = document.cookie.match(new RegExp('(^| )' + 'products' + '=([^;]+)'));
    const navigate = useNavigate();
    const location = useLocation();
    const [quantity, setQuantity] = useState(1);
    async function addToCartFunc(e, q) {
        try { 

            const response = await
                fetch(`${urls.BASE_URL}` + "/zedock-web/cart", {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                        "X-XSRF-TOKEN": getCsrfToken()

                    },
                    body: JSON.stringify({
                        productId: e,
                        quantity: q
                    })
                });

            if (response.status === 401) {
                const existing = expressionProduct?.[0]?.split('products=')[1] ?? "";
                if (!existing.includes(e)) {
                    document.cookie = 'products=' + ((expressionProduct[0] == null)
                        ? e + "-" + q + ","
                        : expressionProduct[0].split('products=')[1] + e + "-" + q + ","
                    );

                }
                else {
                    const regex = new RegExp(e + "-\\d+,");
                    const regex1 = new RegExp(e + "-\\d+");

                    const qty = expressionProduct[0]
                        .split('products=')[1]
                        .match(regex1)?.[0]
                        .split('-')[1] 

                    document.cookie = "products=" +
                        expressionProduct[0]
                            .split('products=')[1]
                            .replace(regex, (e + '-' + (Number(qty) + 1) + ','));

                }

                navigate("/Cart", { state: { from: location } })
                return null;
            }
            navigate("/Cart")
        } catch (error) {
            document.cookie = "products=" + e + "-" + q + ",";
            navigate("/Cart")
            console.error("Error:", error);
        } finally {
        }
    };
    return addToCartFunc;

}
